export var AddToCalendarStatus;
(function (AddToCalendarStatus) {
    AddToCalendarStatus[AddToCalendarStatus["disabled"] = 0] = "disabled";
    AddToCalendarStatus[AddToCalendarStatus["available"] = 1] = "available";
    AddToCalendarStatus[AddToCalendarStatus["adding"] = 2] = "adding";
    AddToCalendarStatus[AddToCalendarStatus["succeeded"] = 3] = "succeeded";
    AddToCalendarStatus[AddToCalendarStatus["failed"] = 4] = "failed";
})(AddToCalendarStatus || (AddToCalendarStatus = {}));
export var IcsCalendarEventType;
(function (IcsCalendarEventType) {
    IcsCalendarEventType[IcsCalendarEventType["UNKNOWN"] = 0] = "UNKNOWN";
    IcsCalendarEventType[IcsCalendarEventType["SINGLE_EVENT_ICS"] = 1] = "SINGLE_EVENT_ICS";
    IcsCalendarEventType[IcsCalendarEventType["MULTIPLE_EVENT_ICS"] = 2] = "MULTIPLE_EVENT_ICS";
})(IcsCalendarEventType || (IcsCalendarEventType = {}));
//# sourceMappingURL=IcsPreviewState.js.map